import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import type { ProjectSummary } from "../types";
import { buildCognitoLogoutUrl } from "../auth";

interface Props {
  projects: ProjectSummary[];
  currentProjectId: string | undefined;
}

export default function TopBar({ projects, currentProjectId }: Props) {
  const navigate = useNavigate();
  const auth = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const onSelectProject = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    if (value === "__new__") {
      navigate("/projects/new");
      return;
    }
    navigate(`/projects/${value}/tasks`);
  };

  const signOut = () => {
    void auth.removeUser();
    window.location.href = buildCognitoLogoutUrl();
  };

  return (
    <div className="topbar">
      <img src="/logo-light.png" alt="Elementa" className="logo" />
      <select value={currentProjectId ?? ""} onChange={onSelectProject}>
        <option value="" disabled>
          Select a project…
        </option>
        {projects.map((p) => (
          <option key={p.projectId} value={p.projectId}>
            {p.name} ({p.jiraProjectKey})
          </option>
        ))}
        <option value="__new__">+ New project…</option>
      </select>
      <span className="spacer" />
      <div className="user-menu">
        <button className="user-button" onClick={() => setMenuOpen((open) => !open)}>
          {(auth.user?.profile.email as string | undefined) ?? "Account"} ▾
        </button>
        {menuOpen && (
          <div className="user-popover">
            <div className="muted" style={{ marginBottom: 8 }}>
              {auth.user?.profile.email as string | undefined}
            </div>
            <button onClick={signOut}>Sign out</button>
          </div>
        )}
      </div>
    </div>
  );
}
